"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getProductOption;
function getProductOption(artFileAttributes, options, optionKey) {
  var _a, _b;
  return (_b = (_a = artFileAttributes[optionKey]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.find(o => o.value === options[optionKey]);
}